import { ZodStringFormat } from "./schemas.js";
import { _isoDateTime, _isoDate, _isoTime, _isoDuration } from "./api2.js";
import { $constructor } from "./core.js";
import { $ZodISODateTime, $ZodISODate, $ZodISOTime, $ZodISODuration } from "./schemas2.js";
const ZodISODateTime = /* @__PURE__ */ $constructor("ZodISODateTime", (inst, def) => {
  $ZodISODateTime.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function datetime(params) {
  return _isoDateTime(ZodISODateTime, params);
}
const ZodISODate = /* @__PURE__ */ $constructor("ZodISODate", (inst, def) => {
  $ZodISODate.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function date(params) {
  return _isoDate(ZodISODate, params);
}
const ZodISOTime = /* @__PURE__ */ $constructor("ZodISOTime", (inst, def) => {
  $ZodISOTime.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function time(params) {
  return _isoTime(ZodISOTime, params);
}
const ZodISODuration = /* @__PURE__ */ $constructor("ZodISODuration", (inst, def) => {
  $ZodISODuration.init(inst, def);
  ZodStringFormat.init(inst, def);
});
function duration(params) {
  return _isoDuration(ZodISODuration, params);
}
export {
  ZodISODate,
  ZodISODateTime,
  ZodISODuration,
  ZodISOTime,
  date,
  datetime,
  duration,
  time
};
//# sourceMappingURL=iso.js.map
